import { extend } from "flarum/extend";
import User from "flarum/models/User";

export default function () {

  extend(User.prototype, 'badges', function(items) {
    const groups = this.groups();
    const allowedGroups = ["Admin", "Moderator"];

    if (groups) {
      groups.forEach(group => {
        if (!allowedGroups.includes(group.nameSingular())) {
          items.remove(`group${group.id()}`);
        }
      });
    }
  });
}
